<template>
    <section class="modal" v-esc="hideModals">
        <form class="container" :class="isDelete && 'delete'" @submit.prevent="submitData" @keydown="(e) => {if(e.key === 'Enter'){e.preventDefault()}}">
            <div class="header flex items-center justify-center text-white">
                <h4 class="font-bold">{{ type }} Customer</h4>
                <a @click.prevent="hideModals" class="x-button">
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9.77932 12.2984C7.72583 14.3649 5.7198 16.3838 3.72239 18.3985C2.70859 17.3804 1.71205 16.3795 0.715501 15.3743C2.70428 13.3769 4.71894 11.3623 6.73792 9.33467C4.70168 7.29844 2.68702 5.27946 0.685303 3.27343C1.6991 2.25531 2.69565 1.25445 3.71808 0.227705C5.7198 2.24668 7.72583 4.26997 9.75775 6.31483C11.8069 4.25272 13.813 2.22943 15.8147 0.210449C16.8457 1.25014 17.8423 2.251 18.8388 3.25617C16.8544 5.24926 14.8397 7.26824 12.8423 9.27427C14.8699 11.3062 16.8759 13.3209 18.869 15.3226C17.8423 16.3493 16.8371 17.3502 15.8147 18.3769C13.8345 16.3881 11.8285 14.3649 9.77932 12.2984Z"
                            fill="white"
                        />
                    </svg>
                </a>
            </div>
            <div class="content">
                <div class="grid grid-cols-3 gap-x-10 gap-y-8">
                    <div class="input-container">
                        <label> First Name </label>
                        <input v-model.trim="details.firstName" :required="!isDelete" ref="firstName"/>
                    </div>
                    <div class="input-container">
                        <label> Last Name </label>
                        <input v-model.trim="details.lastName" :required="!isDelete" />
                    </div>
                    <div class="input-container">
                        <label> Company Name </label>
                        <input v-model.trim="details.company" />
                    </div>

                    <div class="input-container">
                        <label> Email </label>
                        <input v-model.trim="details.email" type="email" />
                    </div>

                    <div class="input-container">
                        <label> Phone </label>
                        <input v-model.trim="details.phone" />
                    </div>

                    <div class="input-container">
                        <label> Address </label>
                        <input v-model.trim="details.address" />
                    </div>
                </div>
                <div class="flex gap-3 pb-6 pt-8">
                    <div class="w-2/3">
                        <div class="input-container">
                            <label> Notes</label>
                            <textarea style="height: 120px" :readonly="isDelete" rows="3" v-model.trim="details.notes" v-on:keyup.enter="(e) => {e.target.value += '\n'}"></textarea>
                        </div>
                    </div>
                    <div class="w-1/3"></div>
                </div>
                <div class="w-full text-center warning" v-if="warning">
                    {{ warning }}
                </div>
                <div class="buttons flex justify-center flex-row pt-6">
                    <button class="save w-full" type="submit"><span>Save</span></button>
                    <button class="cancel w-full"  type="button" @click.prevent="hideModals">Cancel</button>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
export default {
    props: {
        type: String,
        defaultdata: Object,
        isDelete: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        details() {
            return this.$store.state.customers.modal.details;
        },
        warning() {
            return this.$store.state.customers.modal.warning;
        },
    },

    mounted() {
        if (this.defaultdata) {
            this.details = this.defaultdata;
        }

        if(this.type !==  'Delete' ) {
         this.$refs.firstName.focus();
        }
    },

    methods: {
        submitData(e) {
            e.preventDefault();
            this.$emit('submitData');
        },
    },
};
</script>

<style scoped lang="scss">
.warning {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #585858;
}
</style>
